import { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import { useAuth } from "../contexts/AuthContext";
import api from "../lib/api";

export default function AuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const { login } = useAuth();
  const processedRef = useRef(false);

  useEffect(() => {
    const handleCallback = async () => {
      // Prevent double processing
      if (processedRef.current) return;
      processedRef.current = true;
      
      try {
        // Get session_id from URL hash or query params
        let sessionId = null;
        
        // Check hash first (e.g., #session_id=xxx)
        const hash = window.location.hash;
        if (hash) {
          const hashParams = new URLSearchParams(hash.substring(1));
          sessionId = hashParams.get("session_id");
        }
        
        // Fallback to query params
        if (!sessionId) {
          const searchParams = new URLSearchParams(location.search);
          sessionId = searchParams.get("session_id");
        }

        if (!sessionId) {
          toast.error("Oturum bilgisi bulunamadı");
          navigate("/login", { replace: true });
          return;
        }

        // Process session with backend
        const response = await api.processGoogleSession(sessionId);
        const user = response.data.user;
        const token = response.data.token;

        // Store token first for iOS Safari
        if (token) {
          localStorage.setItem("token", token);
        }
        if (user) {
          localStorage.setItem("user", JSON.stringify(user));
        }

        // Login with token
        login(user, token);
        toast.success(`Hoş geldiniz, ${user.name}!`);
        
        // Clear URL and redirect - use setTimeout for iOS Safari
        window.history.replaceState(null, "", "/auth/callback");
        
        setTimeout(() => {
          window.location.href = "/dashboard";
        }, 200);
        
      } catch (error) {
        console.error("Auth callback error:", error);
        toast.error(error.response?.data?.detail || "Giriş başarısız");
        setTimeout(() => {
          window.location.href = "/login";
        }, 100);
      }
    };

    handleCallback();
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="text-center">
        <Loader2 className="w-8 h-8 text-[#4DFFFF] animate-spin mx-auto mb-4" />
        <p className="text-[#B1C1C1]">Giriş yapılıyor...</p>
      </div>
    </div>
  );
}
